import Alert from './Alert'
import Button from './Button'
import { List } from './List'
import Link from './Link'
import Menu from './Menu'
import { Tab } from './Tab'
import { Checkbox } from './Checkbox'
import { Input } from './Input'
import { Slider } from './Slider'
import Pagination from './Pagination'

import { type ThemeWithProps } from '@mui/material'

export default function ComponentsOverrides (theme: ThemeWithProps) {
  return Object.assign(
    Alert(theme),
    Button(theme),
    Menu(theme),
    Input,
    Checkbox,
    List,
    Link(theme),
    Pagination(theme),
    Tab,
    Slider
  )
}
